import React, { useEffect } from "react"
import "register/less/registration.less"
import { captchaKey } from "../../../../shared/src/_base/helpers/captcha"

const ReCaptcha = () => {
    useEffect(() => {
        // Add reCaptcha
        const script = document.createElement("script")
        script.src = `https://www.google.com/recaptcha/api.js?render=explicit`
        script.addEventListener("load", handleLoaded)
        document.body.appendChild(script)
    }, [])

    const handleLoaded = () => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.render(
                {
                    'sitekey': captchaKey,
                    'badge': 'bottomleft',
                    'size': 'invisible',
                }
            )
        })
    }

    return (
        <div></div>
    )
}

export default ReCaptcha